import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import Courses from "../../api/Courses";
import { calculateAverageRating } from "../../Helpers/calculateAverageRating";
import { MatchLocationToCurrency } from "../../main-component/Extensions/MatchLocationToCurrency";
import Cookies from 'js-cookie';
import Search from "../Search/Search";
import "./styles/CourseSectionS3.css"
const ClickHandler = () => {
    window.scrollTo(10, 0);
}






const CourseSectionS3 = (props) => {

    const handleClickedChildToParent = (courseId) => {
        props.onData(courseId);
    }

    const savePageNumber = () => {
        localStorage.setItem("currentPageNumber",props.paginationNumber)
    }

    const [courses, setCourses] = useState([]);
    useEffect(() => {
        if (props.courses) {
            setCourses(props.courses);
        }
    }, [props.courses]);

    const imageBackground = '#eadfcd';

    return (
        <div className={`wpo-popular-area section-padding ${props.pClass} course-section`}>
            <div style={{ marginBottom: "30px" }}></div>
            <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
                <div className="wpo-popular-wrap">
                    <div style={{ 
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
                        gap: '30px',
                        padding: '10px 0'
                    }}>
                        {courses.map((course, index) => (
                           <div 
                                key={index}
                                className="modern-course-card"
                                style={{
                                    background: 'linear-gradient(90deg, rgba(47, 79, 64, 0.045) 1px, transparent 1px), linear-gradient(0deg, rgba(47, 79, 64, 0.035) 1px, transparent 1px), rgba(255, 251, 243, 0.96)',
                                    backgroundSize: '28px 28px, 28px 28px, auto',
                                    border: '1px solid rgba(110, 90, 66, 0.2)',
                                    borderRadius: '8px',
                                    overflow: 'hidden',
                                    boxShadow: '0 18px 42px rgba(58, 45, 34, 0.1)',
                                    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                                    cursor: 'pointer',
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'translateY(-8px)';
                                    e.currentTarget.style.boxShadow = '0 26px 58px rgba(58, 45, 34, 0.14)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'translateY(0)';
                                    e.currentTarget.style.boxShadow = '0 18px 42px rgba(58, 45, 34, 0.1)';
                                }}
                           >
                               {/* Image Section with Gradient Overlay */}
                               <div style={{
                                   position: 'relative',
                                   width: '100%',
                                   height: '220px',
                                   background: imageBackground,
                                   overflow: 'hidden'
                               }}>
                                   {course.courseImage ? (
                                       <img 
                                           src={course.courseImage} 
                                           alt={course.courseName}
                                           style={{
                                               width: '100%',
                                               height: '100%',
                                               objectFit: 'cover',
                                               opacity: 1,
                                               filter: 'saturate(0.92) contrast(1.04)',
                                               transition: 'transform 0.4s ease'
                                           }}
                                           onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
                                           onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                                       />
                                   ) : (
                                       <div style={{
                                           width: '100%',
                                           height: '100%',
                                           display: 'flex',
                                           alignItems: 'center',
                                           justifyContent: 'center',
                                           fontSize: '48px'
                                       }}>
                                           📚
                                       </div>
                                   )}
                                   
                                   {/* Price Badge */}
                                   <div style={{
                                       position: 'absolute',
                                       bottom: '16px',
                                       right: '16px',
                                       background: course.coursePrice === 0 ? '#2f4f40' : '#8d4e2f',
                                       color: '#fffaf0',
                                       padding: '8px 16px',
                                       borderRadius: '4px',
                                       fontWeight: '700',
                                       fontSize: '16px',
                                       boxShadow: '0 8px 18px rgba(58, 45, 34, 0.18)',
                                       display: 'flex',
                                       alignItems: 'center',
                                       gap: '4px'
                                   }}>
                                       {course.coursePrice === 0 ? (
                                           'Ücretsiz'
                                       ) : (
                                           <>{MatchLocationToCurrency()}{course.coursePrice}</>
                                       )}
                                   </div>
                               </div>
                               
                               {/* Content Section */}
                               <div style={{
                                   padding: '24px',
                                   display: 'flex',
                                   flexDirection: 'column',
                                   gap: '16px',
                                   flexGrow: 1
                               }}>
                                   {/* Rating */}
                                   <div style={{
                                       display: 'flex',
                                       alignItems: 'center',
                                       gap: '8px'
                                   }}>
                                       <div style={{
                                           display: 'flex',
                                           alignItems: 'center',
                                           gap: '4px',
                                           background: '#f3eadb',
                                           border: '1px solid rgba(110, 90, 66, 0.16)',
                                           padding: '4px 12px',
                                           borderRadius: '6px'
                                       }}>
                                           <span style={{ color: '#c2734b', fontSize: '16px' }}>⭐</span>
                                           <span style={{ 
                                               fontWeight: '600', 
                                               fontSize: '14px',
                                               color: '#8d4e2f'
                                           }}>
                                               ({calculateAverageRating(course.ratings)})
                                           </span>
                                       </div>
                                   </div>
                                   
                                   {/* Course Title */}
                                   <h2 style={{
                                       margin: 0,
                                       fontFamily: 'Georgia, Times New Roman, serif',
                                       fontSize: '20px',
                                       fontWeight: '500',
                                       lineHeight: '1.4',
                                       color: '#2d241b',
                                       minHeight: '50px',
                                       display: '-webkit-box',
                                       WebkitLineClamp: 2,
                                       WebkitBoxOrient: 'vertical',
                                       overflow: 'hidden'
                                   }}>
                                       <Link 
                                           onClick={() => { savePageNumber(); ClickHandler(); }}
                                           to={props.component === "course" ? `/course-single/${course.courseId}` : `/Instructor/CourseDetail/${course.courseId}`}
                                           style={{
                                               color: '#2d241b',
                                               textDecoration: 'none',
                                               transition: 'color 0.3s ease'
                                           }}
                                           onMouseEnter={(e) => e.currentTarget.style.color = '#8d4e2f'}
                                           onMouseLeave={(e) => e.currentTarget.style.color = '#2d241b'}
                                       >
                                           {course.courseName}
                                       </Link>
                                   </h2>
                                   
                                   {/* Stats */}
                                   <div style={{
                                       display: 'flex',
                                       alignItems: 'center',
                                       gap: '20px',
                                       paddingTop: '12px',
                                       borderTop: '1px solid rgba(110, 90, 66, 0.16)',
                                       marginTop: 'auto'
                                   }}>
                                       <div style={{
                                           display: 'flex',
                                           alignItems: 'center',
                                           gap: '6px',
                                           color: '#6f665a',
                                           fontSize: '14px'
                                       }}>
                                           <span style={{ fontSize: '16px' }}>👥</span>
                                           <span style={{ fontWeight: '500' }}>{course.student || 0}</span>
                                       </div>
                                       <div style={{
                                           display: 'flex',
                                           alignItems: 'center',
                                           gap: '6px',
                                           color: '#6f665a',
                                           fontSize: '14px'
                                       }}>
                                           <span style={{ fontSize: '16px' }}>📖</span>
                                           <span style={{ fontWeight: '500' }}>{course.lesson || 0} Ders</span>
                                       </div>
                                   </div>
                                   
                                   {/* Edit Button for Instructor */}
                                   {props.component === "instructor" && (
                                       <button 
                                           onClick={() => handleClickedChildToParent(course.courseId)}
                                           style={{
                                               marginTop: '12px',
                                               width: '100%',
                                               padding: '12px',
                                               background: '#2f4f40',
                                               color: '#fffaf0',
                                               border: 'none',
                                               borderRadius: '6px',
                                               fontSize: '14px',
                                               fontWeight: '600',
                                               cursor: 'pointer',
                                               transition: 'all 0.3s ease',
                                               boxShadow: '0 12px 24px rgba(47, 79, 64, 0.18)'
                                           }}
                                           onMouseEnter={(e) => {
                                               e.currentTarget.style.transform = 'translateY(-2px)';
                                               e.currentTarget.style.background = '#263f35';
                                               e.currentTarget.style.boxShadow = '0 16px 30px rgba(47, 79, 64, 0.22)';
                                           }}
                                           onMouseLeave={(e) => {
                                               e.currentTarget.style.transform = 'translateY(0)';
                                               e.currentTarget.style.background = '#2f4f40';
                                               e.currentTarget.style.boxShadow = '0 12px 24px rgba(47, 79, 64, 0.18)';
                                           }}
                                       >
                                           ✏️ Düzenle
                                       </button>
                                   )}
                               </div>
                           </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CourseSectionS3;